import React from "react";

import styles from "./Tabs.module.scss";
import classNames from "classnames";

interface TabsProps {
  tabs: string[];
  tabIndex: number;
  getDisabled?: (index: number) => boolean;
  setTabIndex: (index: number) => void;
}

const Tabs = ({ tabs, tabIndex, getDisabled, setTabIndex }: TabsProps) => {
  return (
    <div className={styles.container}>
      {tabs.map((tab, i) => (
        <div
          key={tab}
          className={classNames(
            styles.tab,
            getDisabled !== undefined && getDisabled(i) && styles.disabled,
            tabIndex == i && styles.selected,
          )}
          onClick={() => !getDisabled?.(i) && setTabIndex(i)}
        >
          {tab}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
